import { useCallback, useMemo } from 'react';
import isValidEmail from '../utils/functions/isValidEmail';

const EMAIL_QUERY_PARAM = 'email';

const normalizeEmail = (value: string | null): string => value?.trim().toLowerCase() ?? '';

const removeEmailQueryParamFromUrl = (): void => {
	if (typeof window === 'undefined') {
		return;
	}

	const url = new URL(window.location.href);
	if (!url.searchParams.has(EMAIL_QUERY_PARAM)) {
		return;
	}

	url.searchParams.delete(EMAIL_QUERY_PARAM);

	const nextUrl = `${url.pathname}${url.search}${url.hash}`;
	window.history.replaceState(window.history.state, '', nextUrl);
};

const useLandingPageEmailParam = () => {
	const initialEmailFromQueryParam = useMemo(() => {
		if (typeof window === 'undefined') {
			return '';
		}

		const searchParams = new URLSearchParams(window.location.search);
		const normalizedEmail = normalizeEmail(searchParams.get(EMAIL_QUERY_PARAM));

		if (!normalizedEmail || !isValidEmail(normalizedEmail)) {
			return '';
		}

		return normalizedEmail;
	}, []);

	const consumeEmailQueryParam = useCallback(() => {
		removeEmailQueryParamFromUrl();
	}, []);

	return {
		initialEmailFromQueryParam,
		hasValidEmailQueryParam: initialEmailFromQueryParam.length > 0,
		consumeEmailQueryParam,
	};
};

export default useLandingPageEmailParam;
